import AntdTypography from "antd/es/typography";

const Text = AntdTypography.Text;

export { Text };
